import { TYPES_SEARCH_PRODUCTION_ITEM } from './constants'

export const handleSelectSearchProductionItem = ({
    productionItem,
    productionItems,
    typeSearch,
    setProductionsItems
}: {
    productionItem: any
    productionItems: any[]
    typeSearch: string
    setProductionsItems: (value: React.SetStateAction<any[]>) => void
}) => {
    if (!productionItem) return
    const findProductionItem = productionItems.find(
        _data => _data.id === productionItem?.id
    )

    let initialQuantity = 0
    const isSearchBarCode = typeSearch === TYPES_SEARCH_PRODUCTION_ITEM.BAR_CODE

    if (isSearchBarCode) {
        initialQuantity = 1
    }

    if (!findProductionItem) {
        setProductionsItems(prev => [
            ...prev,
            {
                ...productionItem,
                quantity: initialQuantity
            }
        ])
    } else if (isSearchBarCode) {
        const newData = []

        for (const _productionItem of productionItems) {
            let _quantity = _productionItem.quantity ?? 1
            if (findProductionItem.id === _productionItem.id) {
                _quantity = (_productionItem.quantity ?? 1) + 1
            }

            newData.push({
                ..._productionItem,
                quantity: _quantity
            })
        }

        setProductionsItems([...newData])
    }
}
